import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../images/Logo.png';
import Instagram from '../images/instagram.png';
import '../styles/template.css';

const ContactPage = () => {
  return (
    <div className="container">
      <header>
        <div className="logo-container">
          <img src={Logo} alt="Logo" className="logo" />
        </div>
        <h1>Contact Us</h1>
        <nav>
          <ul>
            <li><Link to='/'>Home</Link></li>
            <li><Link to='/about'>About</Link></li>
            <li><Link to='/partners'>Partners</Link></li>
            <li><Link to='/destinations'>Get Featured</Link></li>
            <li><Link to='/connect'>Meetups</Link></li>
            <li><Link to='/contact'>Contact Us</Link></li>
          </ul>
        </nav>
      </header>
      
      <main>
        <h2 className="main-heading">Get in Touch</h2>
        
        <section className="contact-intro">
          <p>
            We'd love to hear from you! Whether you have questions about our app, feedback on your experience, 
            or ideas for new features, our team is here to help you on your journey of self-discovery.
          </p>
        </section>

        <section className="contact-methods">
          <div className="contact-cards">
            <div className="contact-card">
              <div className="contact-icon">
                <div className="icon-placeholder email-icon">✉</div>
              </div>
              <h3>Email Us</h3>
              <p>Have a question or need support? Interested in partnering with Know Yourself?  Send us an email and we'll get back to you as soon as possible!</p>
              <a href="mailto:support@know-yourself-project.com" className="contact-link">
                support@know-yourself-project.com
              </a>
            </div>

            <div className="contact-card">
              <div className="contact-icon">
                <img src={Instagram} alt="Instagram" className="social-icon" />
              </div>
              <h3>Follow Us</h3>
              <p>Stay updated with our latest features, community stories, and self-discovery tips.</p>
              <a href="https://www.instagram.com/knowyourself_project/" target="_blank" rel="noopener noreferrer" className="contact-link">
                @knowyourself_project
              </a>
            </div>

            <div className="contact-card">
              <div className="contact-icon">
                <div className="icon-placeholder feedback-icon">💭</div>
              </div>
              <h3>Learn how we're connecting the community</h3>
              <p>Check out what's to come with Know Yourself Connect</p>
              <Link to="/connect" className="contact-link">
                Connect
              </Link>
            </div>
          </div>
        </section>

        <section className="contact-cta">
          <h3>Ready to Discover Yourself?</h3>
          <p>
            Download our app and start exploring places that match your unique thinking style. 
            Connect with like-minded people and embark on your journey of self-discovery today.
          </p>
          <div className="app-download-buttons">
            <a href="https://apps.apple.com/us/app/know-yourself-self-discovery/id6504838908" target="_blank" rel="noopener noreferrer" className="download-button">
              Download for iOS
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.grantreynolds.knowyourselfproject" target="_blank" rel="noopener noreferrer" className="download-button">
              Download for Android
            </a>
          </div>
        </section>

        <section className="response-time">
          <div className="response-info">
            <h4>Response Times</h4>
            <ul>
              <li><strong>General Inquiries:</strong> Within 24 hours</li>
              <li><strong>Technical Support:</strong> Within 48 hours</li>
              <li><strong>Partnership Opportunities:</strong> Within 3-5 business days</li>
            </ul>
          </div>
        </section>
      </main>

      <footer>
        <p>&copy; 2026 Know Yourself LLC | All rights reserved.</p>
      </footer>
    </div>
  );
};

export default ContactPage;
